<grid-modal size="large" [isOpen]="isOpen" showCloseButton="true" (isOpenChange)="closeFeedbackModal($event)">
  <grid-icon slot="icon" name="{{feedbackType === 0 ? 'sad-outline' : 'happy-outline'}}" color="grid-content-primary" />
  <h1 slot="title">Valuta la tua esperienza</h1>
  <span slot="body">
    <form (ngSubmit)="inviaFeedback()" #feedbackForm="ngForm">
      <div class="star-rating" *ngIf="feedbackType === 1">
        <grid-icon *ngFor="let star of [1, 2, 3, 4, 5]"
                   name="{{star <= feedbackFormModel.rating ? 'star' : 'star-outline'}}"
                   color="grid-action-primary" size="m"
                   (click)="setRating(star)" />
        <!-- Input nascosto per legare il valore al modulo -->
        <input type="hidden" name="rating" ngModel [(ngModel)]="feedbackFormModel.rating" />
      </div>
		  <grid-input-text-area [(ngModel)]="feedbackFormModel.text" name="text"
                            placeholder="Inserisci un commento sulla tua esperienza..." class="feedback-text-area" maxLength="500" />
      <div class="feedback-button">
      <grid-button type="submit" slot="button-primary" variant="secondary"
                   [gridDisabled]="feedbackType === 0 ? !feedbackFormModel.text || feedbackFormModel.text.length === 0 : !feedbackFormModel.rating">INVIA</grid-button>
      </div>
	</form>
  </span>
</grid-modal>
